module.exports = __webpack_public_path__ + "img/spacerabbi_grid.463820f9.jpg";